<mat-form-field appearance="fill" class="padding-right-3">
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-select
      disableOptionCentering
      (selectionChange)="onSelectionChange()"
      panelClass="example-panel"
      [placeholder]="'SHARED_COMPONENTS.FILTER.' + filter?.filterType | translate"
      [(value)]="selectedValues"
      [multiple]="multiSelect"
    >
      <mat-option *ngFor="let value of filter.data" [value]="value.label">
        {{ value.display | displayTranslation }} ({{ value.count }})
      </mat-option>
    </mat-select>
  </div>
</mat-form-field>
